<template>
    <div>
        <div class="container">
            <el-form :model = "ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
                <el-form-item label="新密码" prop="pass">
                    <el-input size="small" placeholder="请输入密码" v-model="ruleForm.pass" show-password autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input size="small" placeholder="请确认密码" v-model="ruleForm.checkPass" show-password autocomplete="off"></el-input>
                </el-form-item>
                <el-button type="primary" @click="saveEdit">修 改</el-button>
            </el-form>
        </div>
    </div>
</template>
<script>
import {api_prefix} from "../../../../config/api_url";
export default {
    name: 'passwd',
    props:{
    },
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        let validateCheckPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                pass: null,
                checkPass: null,
            },
            rules: {
                pass: [{ validator: validatePass, trigger: 'blur' }],
                checkPass: [{ validator: validateCheckPass, trigger: 'change' }],
            },
        }
    },
    mounted() {
    },
    methods: {
        saveEdit() {
            let that = this;
            that.$refs.ruleForm.validate(async valid => {
                console.log(this.ruleForm)
                //如果valid参数为true则验证通过
                if (!valid) {
                    return
                }
                if (this.ruleForm.pass == null || this.ruleForm.pass == "") {
                    that.$message.error("密码不能为空");
                    return false;
                }
                if (this.ruleForm.checkPass == null || this.ruleForm.checkPass == "") {
                    that.$message.error("确认密码不能为空");
                    return false;
                }
                let loginForm = new FormData();
                loginForm.append("id", localStorage.getItem("uid"));
                loginForm.append("password", this.ruleForm.checkPass);
                let token = localStorage.getItem('token');
                that.$axios({
                    method:"post",
                    url: api_prefix() + "/user/passwd",
                    data: loginForm,
                    headers: {
                        'token': token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then (response => {
                    let res = response.data
                    if (res.code !== 200) {
                        return that.$message.error(res.msg)
                    }else {
                        that.$message.success('修改成功，将转跳至登录页重新登录！');
                        console.log("退出登录")
                        localStorage.removeItem("uid")
                        localStorage.removeItem("avatar")
                        localStorage.removeItem("username")
                        localStorage.removeItem("token")
                        that.$router.push({path:'/login'});
                    }
                })
            });
        }
    }
}
</script>
<style>
.container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.handle-box {
    margin-bottom: 20px;
}

#picker div:nth-child(2){width:100%!important;height:100%!important;}
.webuploader-container {
    position: relative;
}
.webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px,1px,1px,1px);
}
.webuploader-pick {
    position: relative;
    display: inline-block;
    cursor: pointer;
    background:#409eff;
    padding: 8px 12px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
}
.webuploader-pick-hover {
    background: #409EFF;
}

.showMsg{
    margin: 5px;
    background: radial-gradient(#d2b8b8, transparent);
}
</style>



// WEBPACK FOOTER //
// src/components/common/user/Passwd.vue